import * as c from "protobufjs/minimal.js";
import "../sub2/data.js";
import "./feature_sets.js";
const r = "default" in c ? c.default : c;
function l() {
  return {
    $type: "squareup.featurama.model.FeatureStatusForSeller",
    key: void 0,
    subscriptionStatus: void 0,
    activationStatus: void 0
  };
}
const m = {
  $type: "squareup.featurama.model.FeatureStatusForSeller",
  encode(e, t = r.Writer.create()) {
    return e.key !== void 0 && t.uint32(8).int32(e.key), e.subscriptionStatus !== void 0 && d.encode(e.subscriptionStatus, t.uint32(18).fork()).ldelim(), e.activationStatus !== void 0 && s.encode(e.activationStatus, t.uint32(26).fork()).ldelim(), t;
  },
  decode(e, t) {
    const a = e instanceof r.Reader ? e : r.Reader.create(e);
    let u = t === void 0 ? a.len : a.pos + t;
    const i = l();
    for (; a.pos < u; ) {
      const n = a.uint32();
      switch (n >>> 3) {
        case 1:
          if (n !== 8)
            break;
          i.key = a.int32();
          continue;
        case 2:
          if (n !== 18)
            break;
          i.subscriptionStatus = d.decode(a, a.uint32());
          continue;
        case 3:
          if (n !== 26)
            break;
          i.activationStatus = s.decode(a, a.uint32());
          continue;
      }
      if ((n & 7) === 4 || n === 0)
        break;
      a.skipType(n & 7);
    }
    return i;
  },
  create(e) {
    return m.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const t = l();
    return t.key = e.key ?? void 0, t.subscriptionStatus = e.subscriptionStatus !== void 0 && e.subscriptionStatus !== null ? d.fromPartial(e.subscriptionStatus) : void 0, t.activationStatus = e.activationStatus !== void 0 && e.activationStatus !== null ? s.fromPartial(e.activationStatus) : void 0, t;
  }
};
function f() {
  return {
    $type: "squareup.featurama.model.FeatureSubscriptionStatusForSeller",
    isEntitled: void 0,
    isInTrial: void 0,
    metadata: void 0
  };
}
const d = {
  $type: "squareup.featurama.model.FeatureSubscriptionStatusForSeller",
  encode(e, t = r.Writer.create()) {
    return e.isEntitled !== void 0 && t.uint32(8).bool(e.isEntitled), e.isInTrial !== void 0 && t.uint32(16).bool(e.isInTrial), e.metadata !== void 0 && o.encode(e.metadata, t.uint32(26).fork()).ldelim(), t;
  },
  decode(e, t) {
    const a = e instanceof r.Reader ? e : r.Reader.create(e);
    let u = t === void 0 ? a.len : a.pos + t;
    const i = f();
    for (; a.pos < u; ) {
      const n = a.uint32();
      switch (n >>> 3) {
        case 1:
          if (n !== 8)
            break;
          i.isEntitled = a.bool();
          continue;
        case 2:
          if (n !== 16)
            break;
          i.isInTrial = a.bool();
          continue;
        case 3:
          if (n !== 26)
            break;
          i.metadata = o.decode(a, a.uint32());
          continue;
      }
      if ((n & 7) === 4 || n === 0)
        break;
      a.skipType(n & 7);
    }
    return i;
  },
  create(e) {
    return d.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const t = f();
    return t.isEntitled = e.isEntitled ?? void 0, t.isInTrial = e.isInTrial ?? void 0, t.metadata = e.metadata !== void 0 && e.metadata !== null ? o.fromPartial(e.metadata) : void 0, t;
  }
};
function S() {
  return {
    $type: "squareup.featurama.model.FeatureSubscriptionStatusMetadata",
    entitledThroughPlanTokens: [],
    recommendedUpgradeTierToken: void 0
  };
}
const o = {
  $type: "squareup.featurama.model.FeatureSubscriptionStatusMetadata",
  encode(e, t = r.Writer.create()) {
    for (const a of e.entitledThroughPlanTokens)
      t.uint32(10).string(a);
    return e.recommendedUpgradeTierToken !== void 0 && t.uint32(18).string(e.recommendedUpgradeTierToken), t;
  },
  decode(e, t) {
    const a = e instanceof r.Reader ? e : r.Reader.create(e);
    let u = t === void 0 ? a.len : a.pos + t;
    const i = S();
    for (; a.pos < u; ) {
      const n = a.uint32();
      switch (n >>> 3) {
        case 1:
          if (n !== 10)
            break;
          i.entitledThroughPlanTokens.push(a.string());
          continue;
        case 2:
          if (n !== 18)
            break;
          i.recommendedUpgradeTierToken = a.string();
          continue;
      }
      if ((n & 7) === 4 || n === 0)
        break;
      a.skipType(n & 7);
    }
    return i;
  },
  create(e) {
    return o.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var a;
    const t = S();
    return t.entitledThroughPlanTokens = ((a = e.entitledThroughPlanTokens) == null ? void 0 : a.map((u) => u)) || [], t.recommendedUpgradeTierToken = e.recommendedUpgradeTierToken ?? void 0, t;
  }
};
function p() {
  return {
    $type: "squareup.featurama.model.FeatureSetActivationStatusForSeller",
    activationStatus: void 0,
    isActive: void 0
  };
}
const s = {
  $type: "squareup.featurama.model.FeatureSetActivationStatusForSeller",
  encode(e, t = r.Writer.create()) {
    return e.activationStatus !== void 0 && t.uint32(8).int32(e.activationStatus), e.isActive !== void 0 && t.uint32(16).bool(e.isActive), t;
  },
  decode(e, t) {
    const a = e instanceof r.Reader ? e : r.Reader.create(e);
    let u = t === void 0 ? a.len : a.pos + t;
    const i = p();
    for (; a.pos < u; ) {
      const n = a.uint32();
      switch (n >>> 3) {
        case 1:
          if (n !== 8)
            break;
          i.activationStatus = a.int32();
          continue;
        case 2:
          if (n !== 16)
            break;
          i.isActive = a.bool();
          continue;
      }
      if ((n & 7) === 4 || n === 0)
        break;
      a.skipType(n & 7);
    }
    return i;
  },
  create(e) {
    return s.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const t = p();
    return t.activationStatus = e.activationStatus ?? void 0, t.isActive = e.isActive ?? void 0, t;
  }
};
export {
  s as FeatureSetActivationStatusForSeller,
  m as FeatureStatusForSeller,
  d as FeatureSubscriptionStatusForSeller,
  o as FeatureSubscriptionStatusMetadata
};
